// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14dfd937","355":"ca112ee6","453":"0ab4452a","732":"b8a5537e","977":"3afd7391"}[chunkId] + ".chunk.js";
};